import styled from 'styled-components';

import { ImageDetailsPanel } from 'components/damages/styled';
import { Card } from 'components/ui';

export const OBSERVATION_EDIT_CARD_WIDTH = '400px';

export const StyledEditContainer = styled(ImageDetailsPanel)`
  position: absolute;
  margin: 4rem 1rem 1rem;
  max-height: calc(100vh - 114px);
  top: 0;
`;

export const Title = styled.span`
  display: block;
  width: 100%;
  font-size: 1.2rem;
  text-align: left;
  margin: 1rem 1rem 0 1rem;
  font-weight: 700;
`;

export const ContentContainer = styled.div`
  text-align: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
`;

export const Description = styled.div`
  max-width: 15rem;
  margin: 0 1rem 1rem 1rem;
`;

export const StyledStep = styled.p`
  font-size: 1rem;
  text-align: left;
  margin: 0;
`;

export const StyledCard = styled(Card)`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  max-height: 100%;

  .ant-card-body {
    display: flex;
    overflow-y: auto;
    max-height: 100%;
    padding-right: 0;
  }
`;

export const StyledCard2 = styled(Card)`
  position: absolute;
  top: 8px;
  bottom: 8px;
  display: flex;
  flex-direction: column;
  width: ${OBSERVATION_EDIT_CARD_WIDTH};
  margin-bottom: 0 !important;

  .ant-card-head {
    height: 36px;
    padding: 0 6px 0 12px !important;

    .ant-card-head-title {
      font-weight: 400;
    }

    .ant-card-extra {
      display: flex;
      align-items: center;
      height: 100%;
      button {
        background: transparent;
        border: none;
        box-shadow: none;
      }
    }
  }

  .ant-card-body {
    display: flex;
    flex-direction: column;
    overflow-y: auto;

    &:has(.form-fields-container) {
      padding: 0;

      .form-fields-container {
        padding: 12px 12px 0 12px;
      }
    }
  }
`;
